const FETCH_ALL_CONTACTS= "FETCH_ALL_CONTACTS"
const CREATE_CONTACT= "CREATE_CONTACT";
const FETCH_FORMS = "FETCH_FORMS"
const CREATE_FORMS = "CREATE_FORMS"
const AUTHENTICATION = "AUTHENTICATION";
const LOGOUT = "LOGOUT"
const LOGIN = "LOGIN"

export {
  AUTHENTICATION, 
  LOGOUT,
  LOGIN,
  FETCH_ALL_CONTACTS,
  CREATE_CONTACT,
  FETCH_FORMS,
  CREATE_FORMS};